// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-46e5e997] .vendorRoleList .el-form-item {\n  margin-bottom: 0\n}\n[data-v-46e5e997] .selectAllBtnDis .cell {\n  visibility: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
